namespace GeniuzPOS.Product {
    export interface CsTasteForm {
        TasteId: Serenity.StringEditor;
        TasteName: Serenity.StringEditor;
    }

    export class CsTasteForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsTaste';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsTasteForm.init)  {
                CsTasteForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsTasteForm, [
                    'TasteId', w0,
                    'TasteName', w0
                ]);
            }
        }
    }
}
